import Cookies from 'js-cookie'

const TokenKey = 'token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setUserInfo(userInfo) {
  return Cookies.set("userInfo", userInfo)
}

//给sessionStorage存值
export function setStorage(key, value) {
	if(typeof value == "string"){
		sessionStorage.setItem(key, value);
	}else{
		sessionStorage.setItem(key, JSON.stringify(value));
	}
}
// 从sessionStorage取值
export function getStorage(key){
	const str = sessionStorage.getItem(key);
	if( typeof str == "string" ){
		try{
			return JSON.parse(str);
		}catch(e) {
			return str;
		}
	}
	return;
}



// WEBPACK FOOTER //
// ./src/utils/auth.js